<template>
    <header class="header">
        <div v-if="showSandwichMenu" class="navigation-trigger" :class="{'toggled': sliderStatus === 'open'}" data-ma-action="aside-open" @click="toggleSlider()">
            <div class="navigation-trigger__inner">
                <i class="navigation-trigger__line"></i>
                <i class="navigation-trigger__line"></i>
                <i class="navigation-trigger__line"></i>
            </div>
        </div>
        <div class="header__logo hidden-sm-down">
            <h1>
                <img :src="logo" alt="">
                <router-link :to="{ name: 'Home' }">
                    <a>
                        {{ title }}
                    </a>
                </router-link>
            </h1>
        </div>
        <ul class="top-nav">
            <li class="dropdown top-nav__notifications">
                <a href="" data-toggle="dropdown" class="top-nav__notify" aria-expanded="false">
                    <i class="zmdi zmdi-shopping-cart"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-menu--block" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-270px, 35px, 0px);">
                    <div class="listview listview--hover">
                        <div class="listview__header">
                            Notifications

                            <div class="actions">
                                <a href="" class="actions__item zmdi zmdi-check-all" data-ma-action="notifications-clear"></a>
                            </div>
                        </div>

                        <div class="scroll-wrapper listview__scroll scrollbar-inner" style="position: relative;"><div class="listview__scroll scrollbar-inner scroll-content scroll-scrolly_visible" style="height: auto; margin-bottom: 0px; margin-right: 0px; max-height: 350px;">
                            <a href="" class="listview__item">
                                <div class="listview__content">
                                    <div class="listview__heading">234 €</div>
                                    <p>GEE GRTR</p>
                                </div>
                                <div class="input-group">
                                    <span class="pt-4 mr-2">Quantité:</span>
                                    <i class="zmdi zmdi-minus pt-4"></i>
                                    <input type="text" class="form-control">
                                    <i class="zmdi zmdi-plus pt-4"></i>
                                </div>
                            </a>
                        </div>
                            <div class="scroll-element scroll-x scroll-scrolly_visible">
                                <div class="scroll-element_outer">
                                    <div class="scroll-element_size"></div>
                                    <div class="scroll-element_track"></div>
                                    <div class="scroll-bar" style="width: 88px;">
                                    </div>
                                </div>
                            </div><div class="scroll-element scroll-y scroll-scrolly_visible"><div class="scroll-element_outer"><div class="scroll-element_size"></div><div class="scroll-element_track"></div><div class="scroll-bar" style="height: 202px; top: 0px;"></div></div></div></div>

                        <div class="p-1"></div>
                    </div>
                </div>
            </li>
           <!-- <li class="dropdown hidden-xs-down">
                <a href="" data-toggle="dropdown"><i class="zmdi zmdi-apps"></i></a>

                <div class="dropdown-menu dropdown-menu-right dropdown-menu--block" role="menu">
                    <div class="row app-shortcuts">
                        <a class="col-4 app-shortcuts__item" href="">
                            <i class="zmdi zmdi-calendar"></i>
                            <small class="">Calendar</small>
                            <span class="app-shortcuts__helper bg-red"></span>
                        </a>
                        <a class="col-4 app-shortcuts__item" href="">
                            <i class="zmdi zmdi-file-text"></i>
                            <small class="">Files</small>
                            <span class="app-shortcuts__helper bg-blue"></span>
                        </a>
                        <a class="col-4 app-shortcuts__item" href="">
                            <i class="zmdi zmdi-email"></i>
                            <small class="">Email</small>
                            <span class="app-shortcuts__helper bg-teal"></span>
                        </a>
                        <a class="col-4 app-shortcuts__item" href="">
                            <i class="zmdi zmdi-trending-up"></i>
                            <small class="">Reports</small>
                            <span class="app-shortcuts__helper bg-blue-grey"></span>
                        </a>
                        <a class="col-4 app-shortcuts__item" href="">
                            <i class="zmdi zmdi-view-headline"></i>
                            <small class="">News</small>
                            <span class="app-shortcuts__helper bg-orange"></span>
                        </a>
                        <a class="col-4 app-shortcuts__item" href="">
                            <i class="zmdi zmdi-image"></i>
                            <small class="">Gallery</small>
                            <span class="app-shortcuts__helper bg-light-green"></span>
                        </a>
                    </div>
                </div>
            </li>-->
            <li class="ml-4">
                <span>{{ fullname }}</span>
                <a @click="disconnect">
                    <i class="zmdi zmdi-power"></i>
                </a>
            </li>
        </ul>
    </header>
</template>

<script>
    import { getEnvVar } from '@/utils/env'
    export default {

        data() {
            return {
                sliderStatus: 'open'
            }
        },

        props: {
            slider: {default: 'menuSidebar'},
            showSandwichMenu: false
        },

        computed: {
            title() {
                return this.$t(this.$store.getters.getPortalLabel) + ' - ' + this.companyName
            },

            fullname() {
                return this.$store.state.structure.user_info.firstname
                    + ' ' + this.$store.state.structure.user_info.lastname
            },
            companyName() {
                return this.$store.state.structure.company_info.name
            },
            logo() {
              return getEnvVar('VUE_APP_BASE_URL') + this.$store.state.structure.company_info.logo
            }
        },

        methods: {
            async disconnect() {
                await Api.logout()
                this.$store.commit('setStructure', [])
                this.$router.push({name: 'Login'})
            },

            toggleSlider() {
                if(this.sliderStatus === 'open'){
                    this.sliderStatus = 'close'
                }else{
                    this.sliderStatus = 'open'
                }

                this.$eventBus.$emit('toggleSlider', {slider: this.slider, status: this.sliderStatus})
            }
        },

        beforeMount() {
            if(this.isMobileScreen()){
                this.sliderStatus = 'close'
            }
        },

        mounted() {
            this.$eventBus.$on('toggleSlider', (data) => {
                if(data.slider !== this.slider){
                    return
                }

                this.sliderStatus = data.status
            })
        }
    }
</script>